import React from "react";
import "./static/scss/app.scss";
import "react-router-dom";
import { Route, Switch } from "react-router-dom";
import Header from "./components/presentation/header";
import LandingPage from "./components/presentation/landingPage";
import GettingStarted from "./components/presentation/gettingStarted";
import Footer from "./components/presentation/footer";
import AboutUs from "./components/presentation/aboutUs";
import Education from "./components/presentation/education";
import Contacts from "./components/presentation/contact";
import Finalize from "./components/presentation/finalizePage";
import Error from "./components/presentation/error"

import "./App.css";
function App() {
  return (
    <div>
      <Header></Header>
      <Switch>
        <Route path="/education" exact component={Education}></Route>
        <Route path="/contact" exact component={Contacts}></Route>
        <Route path="/getting-started" exact component={GettingStarted}></Route>
        <Route path="/resume-templates" exact component={GettingStarted}></Route>
        <Route path="/about-us" exact component={AboutUs}></Route>
        <Route path="/finalize" exact component={Finalize}></Route> 
        <Route  path="/" exact component={LandingPage}></Route>
        <Route  component={Error}></Route>
        
      </Switch>
      <Footer></Footer>
    </div>
  );
}

export default App;
